import Plyr from 'plyr'
import axios from 'axios'

const FORM_URL = '/ajax/form/signup'

const formResult = (body) => {
  const tempBody = document.createElement('div')
  tempBody.innerHTML = body
  return tempBody
}

const createVideo = function (youtube) {
  if (typeof youtube === undefined) {
    console.log('VideoPlayer.js requires a YouTube embed')
    return false
  }
  const wrapper = document.createElement('div')
  wrapper.setAttribute('class', 'video-player')

  const player = document.createElement('div')
  player.setAttribute('class', 'plyr__video-embed')

  player.innerHTML = `
            <iframe src="${youtube}?origin=https://plyr.io&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1"
                    allowfullscreen
                    allowtransparency
                    allow="autoplay"></iframe>`
  wrapper.appendChild(player)

  const playerPlyr = new Plyr(player, {})
  return {
    wrapper,
    player: playerPlyr,
  }
}

const createNewsletterForm = (id = null) => {
  const wrapper = document.createElement('div')
  wrapper.setAttribute('class', 'video-signup')
  wrapper.dataset.id = id
  axios
    .get(FORM_URL)
    .then(({ data }) => {
      const formContent = formResult(data)
      wrapper.appendChild(formContent)
      return {
        wrapper,
      }
    })
    .catch((error) =>
      ({
        wrapper,
      }))

  return {
    wrapper,
  }
}

export { createVideo, createNewsletterForm }
